// Converte uma string base64 nos bytes correspondentes (para montar um Blob).
// Substitui Buffer.from(base64, "base64"), que não existe no navegador sem polyfill.
const base64ParaBytes = base64 => {
  const binario = window.atob(base64);
  const bytes = new Uint8Array(binario.length);
  for (let i = 0; i < binario.length; i += 1) {
    bytes[i] = binario.charCodeAt(i);
  }
  return bytes;
};

export default base64ParaBytes;
